








import "normalize.css";
import { Component, Vue } from "vue-property-decorator";
import * as Sentry from "@sentry/browser";

import Header from "@/components/Header.vue";
import Timer from "@/components/Timer.vue";
import Footer from "@/components/Footer.vue";
import { PomodoroStatus } from "@/enums/PomodoroStatus";
import * as types from "@/store/mutation-types";
import firebase from "@/firebase";

@Component({
  components: {
    Header,
    Timer,
    Footer
  }
})
export default class App extends Vue {
  mounted(): void {
    this.$ga.page(`${window.location.pathname}${window.location.search}`);

    this.$store.dispatch("restore");
    this.changeThemeColor();

    this.$store.subscribe((mutation, state) => {
      if (
        mutation.type === types.CHANGE_TIMER_STATUS ||
        mutation.type === types.RESET_TIMER
      ) {
        this.changeThemeColor();
      }

      if (mutation.type === types.CHANGE_TIMER_STATUS) {
        switch (state.currentStatus) {
          case PomodoroStatus.WORK: {
            this.$ga.event("notification", "push", "work");
            this.sendNotification("work");
            this.$store.dispatch("playSound");
            this.$store.dispatch("playVibration");
            break;
          }
          default:
            this.$ga.event("notification", "push", "break");
            this.sendNotification("break");
            this.$store.dispatch("playSound");
            this.$store.dispatch("playVibration");

            this.$store.dispatch("sendWebhook");
            break;
        }
      }
    });
  }

  private async sendNotification(type: "work" | "break") {
    try {
      await firebase.sendNotification(type);
    } catch (err) {
      await firebase.requestUserNotificationPermission();
      Sentry.captureException(err);
    }
  }

  // refs: https://stackoverflow.com/questions/44541872/changing-body-styles-in-vue-router
  private changeThemeColor() {
    switch (this.$store.state.currentStatus) {
      case PomodoroStatus.WORK:
        document.body.className = "work-time";
        break;
      default:
        document.body.className = "break-time";
    }
  }
}
